import { useState, useEffect } from 'react';
import ws from 'utils/ws';

// Module-level cache: key → { url, expiresAt }
const cache = new Map();

function cacheKey(bucket, objectKey) {
  return `${bucket}::${objectKey}`;
}

export default function useS3PresignedUrl(bucket, objectKey) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!bucket || !objectKey) return;

    const key = cacheKey(bucket, objectKey);
    const cached = cache.get(key);

    // Reuse cached URL if it expires more than 5 min from now
    if (cached && cached.expiresAt - Date.now() > 5 * 60 * 1000) {
      setUrl(cached.url);
      return;
    }

    let cancelled = false;
    ws.get(`/aws/s3/pre_signed_download_url?bucket=${encodeURIComponent(bucket)}&objectKey=${encodeURIComponent(objectKey)}`)
      .then(res => {
        if (cancelled) return;
        const data = res.data;
        cache.set(key, { url: data.url, expiresAt: data.expirationTime });
        setUrl(data.url);
      })
      .catch(() => {
        // Fall through — url stays null, caller can fallback
      });

    return () => { cancelled = true; };
  }, [bucket, objectKey]);

  return url;
}
